import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth55: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M174.1,64.3l-3.8-10.7-6.6-7.5-6.8-7-7.9-4.9-10.7-4.5-12.2-3.8h-13.7s-12.6,4.5-12.6,4.5l-6.4,1.1-10.9.2c-19,15.6-7.6,42.8-7.6,42.8,0,0,10.4-3.8,25.3-3.8,14.9,0,26.7,14.8,34.7,15.2s39.2-21.4,39.2-21.4v-.2Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M82.5,31.7c-18.6,16.8-7.6,42.8-7.6,42.8-17.7,4.5-19.9,9-27.8,11s-26-18.7-26-18.7l4.2-9.9,2.8-4.5,4.1-3.8,9-5.1,8.1-3.6,7.9-3.8,8.3-1.5,10.2-2.8h6.8s0,0,0,0Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M165.7,138.5s-24.4-14.6-30.3-14.1-13.9,9.8-28.7,14.7-42.3-1.7-42.3-1.7c34.7,30,3.4,47,3.4,47l10.4-.3,12.3.7,11.5,2.8,14.8.2,6.1-1.4,15-6.3,8.2-6.4,6.6-10.8,6.8-15.3,6.3-9h-.1Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M64.5,137.6c35.1,29.5,3.4,47,3.4,47h-12.9s-9.9-1.4-9.9-1.4l-9.6-1.7-8.3-3.5-4.9-4.2-3.8-4.3-5-8.7-4.9-12.7-1-8.9s24.6-10.9,34.2-10.9c9.6,0,22.8,9.2,22.8,9.2h-.1Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M174,64.6l1.8,9,1.4,10.4-.2,18.3-1.8,10.5-2.7,10.1-3,9.5-3.8,6.3c1.6,1.7-20.2-11-20.2-11-6.6-24.6.7-46,.7-46l27.9-17.2h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M21.1,66.9l16.5,15.2c4.3,23.7-4.8,47.8-4.8,47.8l-25.2,9.3,1.3-9.4.9-10.2,2.5-12.4,1.2-10.2,2-11.2,2.2-10.6,3.4-8.3h0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M146.5,81.6c-7.6,27.7-.7,46-.7,46,0,0-4.4-3.1-10-3.1s-11.9,10.1-28.7,14.7c-11.8,3.3-30,6.4-42.3-1.7-19.8-13-31.8-7.6-31.8-7.6,9.1-26.7,4.8-47.8,4.8-47.8,0,0,4.4,3.4,9.5,3.4s18.2-13.9,53-14.8c15.8-.4,24.9,15.2,34.7,15.2s11.3-4.2,11.3-4.2h.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M70.5,185c-11.7-.5-22.5-1.1-33.2-3.3-8.6-1.7-14.9-6.3-19.5-13.7-12.7-20.5-10.9-29.3-7.4-50.8l5.6-34.5c1.6-10,6.1-19.7,11.5-28.2,6.8-10.7,42.6-23.7,56.5-22.5s16.9-1.2,25.1-3.8,16.8-.5,25.1,1.6c11.9,3,22,8.7,29.8,18.3s7.9,8.2,9,13.9c5.2,25.2,5.2,46.6-4.1,70.8l-9.7,16.4c-7.9,13.4-7.3,25.7-28.8,34.2-10.4,4.2-20.9,6-32.2,3.3-8.8-2.1-17.8-3.6-27.6-1.7Z',
			},
		},
	},
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M155.5,123.1s-4.9.2-14.1.2-9.6-9.4-9.6-9.4v-61.3s9.6,6.5,9.6,6.5l6.9,7.2,4.3,1.9,4.1,6.4,3.6,11.2.4,12.7-2.5,8-2.7,16.8v-.2Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M25.6,120.7s4.5,0,17.3-.5,10.7-12.3,10.7-12.3v-53.8s-8,.2-8,.2l-3.9,1.2-8.1,7.2-8.6,10.1-7.4,14.1v12.2s8,21.7,8,21.7h0Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M72.7,115.5A9.7,9.7 0 0 1 92.1,115.5A9.7,9.7 0 0 1 72.7,115.5Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M147.7,149.4c-68.4,22.4-107.5.7-107.5.7l-6.4-11.3c58.4,26.8,117.4,0,117.4,0l-3.5,10.6Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M89.8,150.5c-8.9-33.1-8.4-47-8.4-82.5l8.8-7.9,9.4-5.4,6.5-3,6.5-1.5h8.8s6,1,6,1l4.4,1.4,9.6,6.5,6.9,7.2,4.3,1.9,4.1,6.4,3.6,11.2.4,12.7-2.5,8-2.7,16.8-4.3,15.5c-31.4,13.3-61.3,11.9-61.3,11.9v-.2Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M81.4,68.3c-.7,55.5,8.4,82.5,8.4,82.5-29.2,1.2-56.1-11.9-56.1-11.9l-8.2-18-8-21.7v-12.2s7.6-14.4,7.6-14.4l8.4-9.8,8.1-7.2,3.9-1.2,8-.2,12.1,5,7.4,3.4,8.4,5.6h0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M150,141.1c-32.3,17-78.5,9.7-114.1,1-7.5-15.4-14.9-30.6-17.9-47.7s3.6-15.2,7.2-21.1c3.7-6.7,8.8-11.2,14.5-15.7s11.8-3.9,18.3-1.3,16.6,6.4,23.8,12.2c16.9-18.1,41.2-25.2,59.3-8.7l11.6,10.6c6.3,5.8,9,16.7,7.5,25l-2.9,15.2c-2,10.2-4.3,20.1-7.2,30.6Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M78.4,399.2A12.6,12.6 0 0 1 103.6,399.2A12.6,12.6 0 0 1 78.4,399.2Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M127.3,476.3v-54.4c0-32.4,29.5-24.7,29.5-24.7l5.9,19.1,4.3,15.6,1.8,8.3v8.8s-14.4,15.9-14.4,15.9h-3.4s-8.7,7.4-8.7,7.4l-10.2,4.1h-4.8,0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M25.8,392.1c30.9,0,30.8,27.3,30.8,27.3v46.8s-2.5,1.2-2.5,1.2h-3.5s-3.9-1.6-3.9-1.6l-6.7-4.9-5.1-6-4.8-4.8-10.2-13.6-1.8-8v-18.7s1.1-5.1,1.1-5.1l6.5-12.7h0Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M144.6,364.8v-7.9c-42.2-35.7-97.4-4.4-97.4-4.4v7.1c63.5-25.3,97.4,5.2,97.4,5.2h0Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M144.5,364.9c-20.3-15.1-43.7-15.1-43.7-15.1-22.3,24.1-18.6,106.4-18.6,106.4l28.2,15.8,7.1.2,9.7,4.2h4.8s10.2-4.1,10.2-4.1l8.7-7.4h3.4s14.4-15.9,14.4-15.9v-8.8s-1.8-8.3-1.8-8.3l-4.3-15.6-5.9-19.1-1.8-7.1-5-13.7-5.3-11.6h-.1Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M47.5,359.6c32-12.5,53.6-9.9,53.6-9.9-22.6,33.9-18.6,106.4-18.6,106.4l-2.7-.9-5,3.5-12.7,5.6-5.4,1.8-2.5,1.2h-3.5s-3.9-1.6-3.9-1.6l-6.7-4.9-5.1-6-4.8-4.8-10.2-13.6-1.8-8v-18.7s1.1-5.1,1.1-5.1l6.5-12.7,8.8-13.9,12.7-18.4h.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M118.4,471.8c-15.3-2.7-24.4-8.4-37.5-17.5-8.2,4.6-16,7.9-24.6,10.9-10.4,3.6-16-5.9-23-13.6-5.2-5.7-10.8-11.1-13.2-18.7-4.8-15.4-1.5-31.9,7.6-45.2l19.9-29.1c32.7-9.6,68.3-9.6,98.1,7.8,6.7,14.5,10.6,29.3,15,44.7,2.8,9.8,5.8,19.1,7.8,29.1s-1.1,12-6.7,15.6c-2.3,4.5-6.1,7.7-11.2,8.7-19.9,18.2-28.3,7.9-32.3,7.2Z',
			},
		},
	},
};
